import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ServiceCategory.css";

const categoryData = {
  residential: {
    label: "Residential Construction",
    bgImage: "/images/floor.jpg",
    services: [
      { title: "Villa Construction",      slug: "villa",      desc: "Luxury villa development with structural precision and modern architecture." },
      { title: "Apartment Construction",  slug: "apartment",  desc: "High-quality multi-unit residential buildings with full compliance." },
      { title: "Renovation & Remodeling", slug: "renovation", desc: "Transform existing spaces with structural upgrades and modern design." },
    ],
  },
  commercial: {
    label: "Commercial Construction",
    bgImage: "/images/cost.webp",
    services: [
      { title: "Office Buildings",      slug: "office",     desc: "Professional office construction tailored for productivity and corporate branding." },
      { title: "Retail Spaces",         slug: "retail",     desc: "Retail and commercial construction designed to enhance customer flow." },
      { title: "Industrial Structures", slug: "industrial", desc: "Robust industrial buildings with safety compliance and structural reliability." },
    ],
  },
  interior: {
    label: "Interior Design",
    bgImage: "/images/interior.jpg",
    services: [
      { title: "Home Interior",   slug: "homeinterior",  desc: "Complete interior solutions focused on comfort and aesthetic elegance." },
      { title: "Office Interior", slug: "officeinterior",desc: "Corporate interiors enhancing productivity and brand identity." },
      { title: "Space Planning",  slug: "spaceplanning", desc: "Strategic space utilization to maximize efficiency and functionality." },
    ],
  },
  designs: {
    label: "Designs",
    bgImage: "/images/3d-elevation.jpg",
    services: [
      { title: "Floor Plan",   slug: "floorplan",   desc: "Detailed 2D floor plans with accurate dimensions and room layouts." },
      { title: "2D Layout",    slug: "layout2d",    desc: "Precise 2D design layouts for spaces of all sizes and purposes." },
      { title: "3D Elevation", slug: "elevation3d", desc: "Stunning 3D exterior and interior elevation renders for your project." },
    ],
  },
};

const ServiceCategory = () => {
  const { category } = useParams();
  const navigate = useNavigate();

  const cat = categoryData[category];

  if (!cat) {
    return <h2 style={{ textAlign: "center", padding: "80px" }}>Category Not Found</h2>;
  }

  return (
    <div className="sc-page">

      <div
        className="sc-hero"
        style={{ backgroundImage: `url('${cat.bgImage}')` }}
      >
        {/* Dark overlay */}
        <div className="sc-hero-overlay" />

        {/* Gold corner brackets */}
        <div className="sc-corner sc-corner-tl" />
        <div className="sc-corner sc-corner-tr" />
        <div className="sc-corner sc-corner-bl" />
        <div className="sc-corner sc-corner-br" />

        {/* Back button */}
        <button className="sc-back-btn" onClick={() => navigate("/services/main")}>
          ← Back
        </button>

        {/* Central content — NO emoji icon */}
        <div className="sc-hero-content">
          <p className="sc-hero-tag">◆ OUR SERVICES ◆</p>
          <h1>{cat.label}</h1>
          <div className="sc-hero-divider" />
          <p className="sc-hero-sub">Select a service to learn more</p>
        </div>
      </div>

      {/* SERVICE CARDS */}
      <div className="sc-grid">
        {cat.services.map((item) => (
          <div
            key={item.slug}
            className="sc-card"
            onClick={() => navigate(`/services/detail/${item.slug}`)}
          >
            <div className="sc-card-inner">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
              <span className="sc-link">Learn More →</span>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default ServiceCategory;